module.exports = __webpack_public_path__ + "static/media/buildings.d890330f.png";